
<v-expand-x-transition v-if="data">
    <v-row class="zoom-panel">
        <v-col class="step-first-column col-3 zoom-first-col not-favorite">
            <div
                class="v-flex"
                :class="bid.favorite ? 'favorite primary white--text' : 'not-favorite black--text'"
                style="border-radius: 4px"
            >
                <div style="margin-top: 1px" class="mr-3">
                    <a @click="onClose">
                        <i class="fas fa-arrow-left" :class="bid.favorite ? 'white--text' : 'primary--text'" style="font-size: 15px"></i>
                    </a>
                </div>
                <div class="space-between">
                    <span v-if="bid.favorite" ><i class="fas fa-star mr-1"></i>{{ $t("repair.bid.label.favorite") }}</span>
                    <span v-if="!bid.favorite"><i class="far fa-star mr-1"></i></span>

                    <span class="mr-5">{{ $t("repair.bid.name." + bid.bidname) }}</span>
                </div>
            </div>

            <c-flip-card :top="-21" :color="bid.favorite?'white':'#0a68b8'">
                <template slot="front">
                    <div class="w-100">
                        <v-row class="no-frame mt-2">
                            <v-col class="no-frame">
                                <f-read-only-field
                                    label="Bearbeitungsstatus"
                                    :value="bid.status.name"
                                />
                            </v-col>
                        </v-row>
                        <v-row class="no-frame" v-show="bid.status.id !== 0">
                            <v-col class="no-frame">
                                <f-read-only-field
                                    label="Ausführendes Unternehmen"
                                    :value="bid.manufacturer.name"
                                />
                            </v-col>
                        </v-row>
                        <v-row class="no-frame" v-show="bid.status.id !== 0">
                            <v-col class="no-frame">
                                <f-read-only-field
                                    label="Email Ansprechpartner"
                                    :value="bid.email"
                                />
                            </v-col>
                        </v-row>
                        <v-row class="no-frame" v-show="bid.status.id !== 0">
                            <v-col class="no-frame mr-2">
                                <f-read-only-field
                                    :label="$t('repair.bid.label.number')"
                                    :value="bid.number"
                                />
                           </v-col>
                            <v-col class="no-frame ml-2">
                                <f-read-only-field
                                    label="Lieferzeit"
                                    :value="bid.deliverytime.name"
                                />
                            </v-col>
                        </v-row>

                        <inc-calculation-sum
                            v-if          = "bid.calculations"
                            :calculations = "bid.calculations"
                            style         = "margin-top: 39px"
                        />
                    </div>
                </template>
                <template slot="back">
                    <div class="w-100">
                        <inc-bid-documents v-if="data" :collection-id="data.id" :bid-id="bid.id"/>
                    </div>
                </template>
            </c-flip-card>
        </v-col>

        <v-col class="zoom-site-panel v-flex" style="max-width: calc(75% - 12px); flex-wrap: wrap; overflow-y: scroll; flex-direction: row;
align-content: flex-start; ">
            <inc-bid-calculation
                v-for     = "(calculation, index) in bid.calculations"
                :calculation = "calculation"
                :favorite = "bid.favorite"
                :status   = "bid.status"
                :key      = "index"
                style     = "width: calc(33.33% - 10px); margin: 0 5px 10px;"
                :form     = "form"
                :readonly = "readonly"
            />
        </v-col>
    </v-row>
</v-expand-x-transition>
